import { render, staticRenderFns } from "./AGCCheckboxGroup.vue?vue&type=template&id=232087dd&scoped=true&"
import script from "./AGCCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./AGCCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./AGCCheckboxGroup.vue?vue&type=style&index=0&id=232087dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232087dd",
  null
  
)

export default component.exports